import { Formik } from 'formik';

import { Messages } from 'config';
import { ButtonColors } from 'types';
import { useAppSelector } from 'store';
import { Icon } from 'components/icon';
import * as CommonStyles from 'components/styles';
import { selectAuthUser } from 'store/slices/auth';
import { Dialog, DialogType } from 'components/dialog';
import { Button, ButtonTypes } from 'components/button';
import { useAlert, isMobile, handleMutation } from 'hooks';
import { passwordValidationRules } from 'utils/validation';
import { useUpdatePasswordMutation } from 'store/api/users';
import { InputField, FieldValidationRules } from 'components/fields';

import * as Styles from './styles';
import { initialValues, validationSchema } from './config';
import { FormValues, ChangePasswordDialogProps } from './types';

export const ChangePasswordDialog = ({
  trigger,
}: ChangePasswordDialogProps) => {
  const mobile = isMobile();
  const { showSuccessAlert } = useAlert();
  const authUser = useAppSelector(selectAuthUser);

  const [updatePassword, mutation] = useUpdatePasswordMutation();
  handleMutation(mutation);

  return (
    <Dialog
      showCloseButton
      title="Change password"
      closeOnDocumentClick={false}
      trigger={
        trigger || (
          <Styles.StyledButton
            padding="0"
            transparent={true}
            icon={<Icon.Edit />}
            text="Change password"
            colorType={ButtonColors.LightBlue}
          />
        )
      }
    >
      {(close, _, ButtonWrap) => (
        <Formik<FormValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const response = await updatePassword({
              ...values,
              id: Number(authUser?.id),
              newPassword: values.password,
            }).unwrap();

            if (response?.id) {
              showSuccessAlert(`Password ${Messages.UPDATED_SUCCESSFULLY}`);
              close();
            }
          }}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form gap={24}>
              <InputField
                type="password"
                name="oldPassword"
                label="Old Password"
                placeholder="Enter password"
              />

              <InputField
                type="password"
                name="password"
                label="Password"
                placeholder="Enter password"
              />

              <FieldValidationRules
                name="password"
                rules={passwordValidationRules}
              />

              <InputField
                type="password"
                name="passwordRepeat"
                label="Password repeat"
                placeholder="Enter password repeat"
              />

              <ButtonWrap type={DialogType.Plain}>
                <Button
                  text="Cancel"
                  onClick={close}
                  fullWidth={mobile}
                  colorType={ButtonColors.LightBlue}
                />
                <Button
                  text="Confirm"
                  fullWidth={mobile}
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                />
              </ButtonWrap>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
